import ConfigDefault from '../Config';
import ConfigAme from '../ConfigAme';
import { FaceTecSDK } from '../../../../public/core-sdk/FaceTecSDK.js/FaceTecSDK';
import { SampleAppUtilities } from './SampleAppUtilities';

const isSuperOnboarding = window.location.pathname.includes('super-onboarding');
const Config = isSuperOnboarding ? ConfigAme : ConfigDefault;

export default (() => {
  let currentTheme = 'FaceTec Theme';
  const themeResourceDirectory = '../../sample-app-resources/images/themes/';

  function getCustomizationForTheme() {
    let currentCustomization = new FaceTecSDK.FaceTecCustomization();

    currentCustomization = Config.retrieveConfigurationWizardCustomization(FaceTecSDK);

    return currentCustomization;
  }

  function getLowLightCustomizationForTheme(theme) {
    const currentLowLightCustomization = getCustomizationForTheme(theme);

    return currentLowLightCustomization;
  }

  function getDynamicDimmingCustomizationForTheme(theme) {
    const currentDynamicDimmingCustomization = getCustomizationForTheme(theme);

    return currentDynamicDimmingCustomization;
  }

  function setAppTheme(theme) {
    Config.currentCustomization = getCustomizationForTheme(theme);
    const currentLowLightCustomization = getLowLightCustomizationForTheme(theme);
    const currentDynamicDimmingCustomization = getDynamicDimmingCustomizationForTheme(theme);
    FaceTecSDK.setCustomization(Config.currentCustomization);
    FaceTecSDK.setLowLightCustomization(currentLowLightCustomization);
    FaceTecSDK.setDynamicDimmingCustomization(currentDynamicDimmingCustomization);
  }

  function updateThemeTransitionView() {
    const transitionViewImage = '';
    let transitionViewClass = 'theme-transition-overlay__';
    let deviceType = 'desktop';
    if (SampleAppUtilities.isLikelyMobileDevice()) {
      deviceType = 'mobile';
    }
    transitionViewClass = 'default';

    transitionViewClass += `__${deviceType}`;
    document.getElementById('theme-transition-overlay-img').src = transitionViewImage;
    document.getElementById('theme-transition-overlay').className = transitionViewClass;
  }

  function showNewTheme() {
    let themes = [''];
    if (Config.wasSDKConfiguredWithConfigWizard === true) {
      themes = ['Config Wizard Theme', 'FaceTec Theme', 'Pseudo-Fullscreen', 'Well-Rounded', 'Bitcoin Exchange', 'eKYC', 'Sample Bank'];
    } else {
      themes = ['FaceTec Theme', 'Pseudo-Fullscreen', 'Well-Rounded', 'Bitcoin Exchange', 'eKYC', 'Sample Bank'];
    }
    let currentThemeIndex = themes.indexOf(currentTheme);
    currentThemeIndex = currentThemeIndex >= themes.length - 1 ? 0 : currentThemeIndex + 1;
    currentTheme = themes[currentThemeIndex];
    setAppTheme(currentTheme);
    updateThemeTransitionView();
    SampleAppUtilities.displayStatus(`Theme set to: ${currentTheme}`);
  }

  function getCurrentTheme() {
    currentTheme = Config.wasSDKConfiguredWithConfigWizard ? 'Config Wizard Theme' : 'FaceTec Theme';
    currentTheme = 'Pseudo-Fullscreen';
    return currentTheme;
  }
  return {
    getCurrentTheme,
    themeResourceDirectory,
    setAppTheme(theme) {
      setAppTheme(theme);
    },
    showNewTheme,
  };
})();
